import React from 'react';
import { Slide, SlideComponentProps } from './Slide';
import { RenderField } from '@/form/fields/RenderField.tsx';
import { FCWW } from '../../../types.ts';

type QuestionProps = SlideComponentProps;

export const Question: FCWW<QuestionProps> = ({ slide, children, ...slideProps }) => {
  const slideId = slide.id;
  const cssClasses = ['type-question', 'num-fields-' + slide.fields.length];

  return (
    <Slide {...slideProps} slide={slide} className={cssClasses.join(' ')}>
      {slide.fields.map((field) => {
        return <RenderField slideId={slideId} key={field.name} field={field} />;
      })}
      {children}
    </Slide>
  );
};
